'use client';

import Image from 'next/image';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modale } from '../modale/Modale';
import { BurgerMenu } from '../burger/BurgerMenu';
import { BurgerButton } from '../burger/BurgerButton';
import { useState, useEffect, useRef } from 'react';
import { INavbar } from '@/types/components/navbar';

export const Navbar: React.FC<INavbar> = ({
  logo,
  iconSpots,
  iconEvents,
  iconMap,
  iconDl,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModaleVisible, setIsModaleVisible] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);
  const openModale = () => setIsModaleVisible(true);
  const closeModale = () => setIsModaleVisible(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        closeMenu();
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen]);

  return (
    <>
      <nav className="bg-black-500 flex justify-between p-2 xl:mx-[4.5vw] lg:mx-[4vw] md:mx-[0vw] sm:mx-[0vw] xs:mx-[1vw]">
        <Link
          href="/"
          title="Retourner à l'accueil"
          className="flex items-center"
        >
          <Image
            src={logo}
            alt="Logo The Club"
            title="Logo The Club"
            width={250}
            height={250}
            priority
            className="xl:w-[20vw] lg:w-[25vw] md:w-[32vw] sm:w-[33vw] xs:w-[52vw] md:ml-5 lg:ml-0"
          />

          <h1 className="text-3xl font-bold sr-only">The Club</h1>
        </Link>

        <div className="flex items-center md:mr-5">
          <BurgerButton isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
        </div>
        <div
          className={`lg:flex items-center space-x-6 text-white font-primaryBold ${
            isMenuOpen ? 'hidden' : 'hidden lg:flex'
          }`}
          aria-hidden={isMenuOpen ? 'true' : 'false'}
        >
          <Link
            href="/spots"
            title="Redirection vers les spots"
            className="hover:text-red-600"
          >
            <FontAwesomeIcon icon={iconSpots} className="mr-2 size-[17px]" />
            Spots
          </Link>
          <Link
            href="/events"
            title="Redirection vers les évènements"
            className="hover:text-red-600"
          >
            <FontAwesomeIcon icon={iconEvents} className="mr-2 size-[17px]" />
            Évènements
          </Link>
          {/* <Link
            href="/map"
            title="Redirection vers la map"
            className="hover:text-red-600"
          >
            <FontAwesomeIcon icon={iconMap} className="mr-2 size-[17px]" />
            Carte
          </Link> */}
          <button
            title="Ouvrir la modale du QRcode"
            className="bg-red-600 hover:bg-red-800 py-2 px-4 rounded-lg"
            onClick={openModale}
          >
            <FontAwesomeIcon icon={iconDl} className="mr-2 size-[17px]" />
            Télécharger l&apos;app
          </button>
        </div>
      </nav>

      {isMenuOpen && (
        <div ref={menuRef}>
          <BurgerMenu
            iconSpots={iconSpots}
            iconEvents={iconEvents}
            iconMap={iconMap}
            iconDl={iconDl}
            openModale={openModale}
            closeMenu={closeMenu}
          />
        </div>
      )}

      {isModaleVisible && <Modale closeModale={closeModale} />}
    </>
  );
};
